export class HttpError extends Error {
    readonly status: number;
    readonly responseData: unknown;

    constructor(status: number, responseData: unknown) {
        const serializedResponse = typeof responseData === 'string'
            ? responseData
            : JSON.stringify(responseData);
        const responseDetails = serializedResponse ? `; response: ${serializedResponse}` : '';

        super(`HTTP error! status: ${status}${responseDetails}`);
        this.name = 'HttpError';
        this.status = status;
        this.responseData = responseData;
    }
}

export function createHttpError(status: number, responseText: string): HttpError {
    let responseData: unknown = responseText;

    if (responseText) {
        try {
            responseData = JSON.parse(responseText);
        } catch {
            // Keep non-JSON response bodies verbatim so diagnostics are not lost.
        }
    }

    return new HttpError(status, responseData);
}
